import "./stub";
import { CmpController, attachPublicApi } from "./cmp";
import { SDK_NAME } from "./constants";
import { log } from "./debug";
import { consoleRequested, openConsole, closeConsole } from "./console_loader";

declare global {
  interface Window {
    __CMP_BASE__?: { apiBase?: string; propertyKey?: string; country?: string };
  }
}

log("boot", "cmp.js loaded", { readyState: document.readyState });

async function boot() {
  const cfg = window.__CMP_BASE__;
  const apiBase = (cfg?.apiBase || window.location.origin).replace(/\/$/, "");
  // Open the debug console early so it can also explain boot/config failures.
  if (consoleRequested()) openConsole(apiBase);
  if (!cfg?.propertyKey) {
    console.warn(`[${SDK_NAME}] missing window.__CMP_BASE__.propertyKey`);
    log("error", "missing window.__CMP_BASE__.propertyKey");
    const api = (window as unknown as Record<string, Record<string, unknown> | undefined>)[SDK_NAME];
    if (api) api.console = (open?: unknown) => (open === false || open === "close" || open === "off" ? closeConsole() : openConsole(apiBase));
    return;
  }
  const controller = new CmpController({ apiBase, propertyKey: cfg.propertyKey });
  attachPublicApi(controller);
  try {
    await controller.init();
  } catch (err) {
    log("error", `init failed: ${err instanceof Error ? err.message : String(err)}`);
    throw err;
  }
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => { void boot(); });
else void boot();
